import { useTolgeeContext } from '../../../contexts/TolgeeContext';

export const useLanguageDropdown = () => {
    const { updateCurrentLanguage, currentLanguage } = useTolgeeContext();

    return {
        currentLanguage,
        updateLanguage: updateCurrentLanguage,
    };
};
